import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CatalogCrudSection from '../components/catalog/CatalogCrudSection';
import CostLedgerConfigSection from '../components/catalog/CostLedgerConfigSection';
import { fetchCatalogEntity } from '../features/inventory/catalogCrudSlice';
import StockManagerLayout from '../components/StockManagerLayout';

const catalogSections = [
  {
    key: 'cost_ledger_config',
    title: 'Cost & Ledger Config',
    custom: 'cost-ledger-config',
  },
  {
    key: 'products',
    title: 'Products',
    entity: 'products',
    fields: [
      { name: 'product_code', label: 'Product Code', required: true },
      {
        name: 'product_name_eng',
        label: 'Product Name English',
        required: true,
      },
      { name: 'product_name_tel', label: 'Product Name Telugu' },
    ],
  },
  {
    key: 'brands',
    title: 'Brands',
    entity: 'brands',
    fields: [
        { name: 'brand_code', label: 'Brand Code', required: true },
      { name: 'brand_name_english', label: 'Brand Name English', required: true },
      { name: 'brand_name_telugu', label: 'Brand Name Telugu' },
    //   { name: 'description', label: 'Description' },
    ],
  },
  {
    key: 'categories',
    title: 'Categories',
    entity: 'categories',
    fields: [
        { name: 'category_code', label: 'Category Code', required: true },
      {
        name: 'category_name_english',
        label: 'Category Name English',
        required: true,
      },
      { name: 'category_name_telugu', label: 'Category Name Telugu' },
    //   { name: 'description', label: 'Description' },
    ],
  },
  {
    key: 'employees',
    title: 'Employees',
    entity: 'employees',
  fields: [
    { name: 'emp_code', label: 'Employee Code', required: true },

    { name: 'first_name', label: 'First Name', required: true },
    { name: 'last_name', label: 'Last Name' },

    { name: 'phone', label: 'Phone' },
    { name: 'email', label: 'Email' },

    { name: 'department', label: 'Department' },
    { name: 'designation', label: 'Designation' },

    { name: 'salary', label: 'Salary', type: 'number' },

    { name: 'date_of_joining', label: 'Date of Joining', type: 'date' },

    { name: 'is_active', label: 'Active', type: 'checkbox' },

    // 🔒 Read-only system fields
    { name: 'created_at', label: 'Created At', readOnly: true },
    { name: 'updated_at', label: 'Updated At', readOnly: true },
  ],
  },
  {
    key: 'outlets',
    title: 'Outlets',
    entity: 'outlets',
    fields: [
      { name: 'outlet_code', label: 'Outlet Code', required: true },
      { name: 'outlet_name', label: 'Outlet Name', required: true },
      { name: 'address', label: 'Address' },
      { name: 'phone', label: 'Phone' },
    ],
  },
  {
    key: 'units',
    title: 'Units',
    entity: 'units',
    fields: [
      { name: 'unit_name', label: 'Unit Name', required: true },
      { name: 'unit_short_code', label: 'Unit Short Code' },
    ],
  },
  {
    key: 'stakeholders',
    title: 'Stakeholders',
    entity: 'stakeholders',
    fields: [
      { name: 'stackholder_code', label: 'Stakeholder Code', required: true },
      { name: 'stakeholder_name', label: 'Stakeholder Name', required: true },
      { name: 'stakeholder_type', label: 'Type', suggestions: [
        { value: 'supplier', label: 'Supplier' },
        { value: 'vendor', label: 'Vendor' },
        { value: 'customer', label: 'Customer' },
        { value: 'outlet', label: 'Outlet' },
        { value: 'internal_packing', label: 'Internal packing' },
        { value: 'dailyfainance', label: 'Daily Finance' },
      ] },
      { name: 'gst', label: 'GST' },
      { name: 'phone', label: 'Phone' },
      { name: 'email', label: 'Email' },
      { name: 'address', label: 'Address' },
    ],
  },
 {
  key: 'warehouses',
  title: 'Warehouses',
  entity: 'warehouses',
  fields: [
    { name: 'warehouse_code', label: 'Warehouse Code', required: true },
    { name: 'warehouse_name', label: 'Warehouse Name', required: true },
    { name: 'address', label: 'Address' },
    { name: 'phone', label: 'Phone' },
  ],
},
  {
    key: 'product_barcodes',
    title: 'Product Barcodes',
    entity: 'product-barcodes',
    fields: [
      {
        name: 'product_id',
        label: 'Product',
        type: 'select',
        optionsKey: 'products',
        valueKey: 'id',
        labelKey: 'product_name_eng',
        required: true,
      },
      {
        name: 'brand_id',
        label: 'Brand',
        type: 'select',
        optionsKey: 'brands',
        valueKey: 'id',
        labelKey: 'brand_name_english',
        required: true,
      },
      {
        name: 'category_id',
        label: 'Category',
        type: 'select',
        optionsKey: 'categories',
        valueKey: 'id',
        labelKey: 'category_name_english',
        required: true,
      },
      {
        name: 'unit_id',
        label: 'Unit',
        type: 'select',
        optionsKey: 'units',
        valueKey: 'id',
        labelKey: 'unit_name',
        required: true,
      },
      { name: 'quantity', label: 'Quantity', type: 'number', required: true },
      { name: 'barcode', label: 'Barcode' },
      { name: 'mk_barcode', label: 'MK Barcode', readOnly: true },
      { name: 'image_id', label: 'Image' },
      { name: 'hsncode', label: 'HSN Code', type: 'number' },

      { name: 'product_name_eng', label: 'Product Name', readOnly: true },
      { name: 'product_code', label: 'Product Code', readOnly: true },
      { name: 'brand_name_english', label: 'Brand Name', readOnly: true },
      { name: 'category_name_english', label: 'Category Name', readOnly: true },
      { name: 'unit_name', label: 'Unit Name', readOnly: true },
      { name: 'unit_short_code', label: 'Unit Code', readOnly: true },
      { name: 'is_active', label: 'Active', type: 'checkbox', readOnly: true },
      { name: 'created_at', label: 'Created At', readOnly: true },
      { name: 'updated_at', label: 'Updated At', readOnly: true },
    ],
  },
  {
    key: 'images',
    title: 'Images',
    entity: 'images',
    fields: [
      { name: 'image_name', label: 'Image Name', required: true },
      { name: 'url', label: 'Image URL', required: true },
      { name: 'created_at', label: 'Created At', readOnly: true },
      { name: 'updated_at', label: 'Updated At', readOnly: true },
    ],
  },
  {
    key: 'gst_rates',
    title: 'GST Rates',
    entity: 'gst-rates',
    fields: [
      { name: 'hsncode', label: 'HSN Code', type: 'number', required: true },
      { name: 'gst_rate', label: 'GST %', type: 'number', required: true },
      { name: 'description', label: 'Description' },
      { name: 'is_active', label: 'Active', type: 'checkbox' },
    ],
  },
];

const StockManagerCatalogPage = () => {
  const dispatch = useDispatch();

  const { data = {}, loadingByEntity = {} } = useSelector((state) => state.catalogCrud || {});
  const [activeKey, setActiveKey] = useState('products');

  const getRequiredEntities = (key) => {
    const section = catalogSections.find((item) => item.key === key);
    const entities = new Set();

    if (section?.entity) {
      entities.add(section.entity);
    }

    if (key === 'product_barcodes') {
      ['products', 'brands', 'categories', 'units', 'images'].forEach((entity) =>
        entities.add(entity)
      );
    }

    if (key === 'images') {
      entities.add('images');
    }

    return [...entities];
  };

  useEffect(() => {
    getRequiredEntities(activeKey).forEach((entity) => {
      if (!data[entity]) {
        dispatch(fetchCatalogEntity(entity));
      }
    });
  }, [activeKey, data, dispatch]);

  const catalogOptions = {
    products: data.products || [],
    brands: data.brands || [],
    categories: data.categories || [],
    units: data.units || [],
    employees: data.employees || [],
    outlets: data.outlets || [],
    stakeholders: data.stakeholders || [],
    warehouses: data.warehouses || [],
    images: data.images || [],
    'gst-rates': data['gst-rates'] || [],
    'product-barcodes': data['product-barcodes'] || [],
  };

  const activeSection = catalogSections.find((item) => item.key === activeKey);
  const requiredEntities = getRequiredEntities(activeKey);
  const activeLoading = requiredEntities.some(
    (entity) => loadingByEntity[entity] || !data[entity]
  );

  return (
    <StockManagerLayout>
    <main className="min-w-0 space-y-4 p-1 sm:p-4">
      <section className="bg-white border rounded-xl shadow-sm p-4">
        <h1 className="text-xl font-bold text-gray-800">
          Catalog Management
        </h1>
        <p className="text-sm text-gray-500">
          Manage catalog products, brands, categories, employees, outlets,
          units, stakeholders, warehouses, product barcodes, GST rates, images,
          and cost/ledger configurations.
        </p>
      </section>

      <section aria-label="Catalog sections" className="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap">
        {catalogSections.map((section) => (
          <button
            key={section.key}
            type="button"
            aria-pressed={activeKey === section.key}
            onClick={() => setActiveKey(section.key)}
            className={`min-h-11 min-w-0 max-w-full rounded-lg border px-3 py-2 text-sm leading-5 whitespace-normal break-words focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 sm:shrink-0 sm:px-4 ${
              activeKey === section.key
                ? 'border-blue-600 bg-blue-600 text-white'
                : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-100'
            }`}
          >
            {section.title}
          </button>
        ))}
      </section>

      {activeSection && activeLoading && activeSection.custom !== 'cost-ledger-config' ? (
        <section className="rounded-xl border bg-white p-8 text-center shadow-sm">
          <div className="mx-auto mb-3 h-10 w-10 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600" />
          <div className="text-sm font-semibold text-gray-800">
            Loading {activeSection.title}
          </div>
          <div className="mt-1 text-xs text-gray-500">
            Fetching catalog data and dropdown options
          </div>
        </section>
      ) : activeSection && (
        activeSection.custom === 'cost-ledger-config' ? (
          <CostLedgerConfigSection />
        ) : (
          <CatalogCrudSection
            title={activeSection.title}
            entity={activeSection.entity}
            fields={activeSection.fields}
            catalogOptions={catalogOptions}
          />
        )
      )}
    </main>
    </StockManagerLayout>
  );
};

export default StockManagerCatalogPage;
